module.exports = __webpack_public_path__ + "img/bg_resize_castle_back.d2501290.png";